import React from "react";
import { ViewLead } from "./ViewLeadShared";

/** Tenant detail view (`/tenants/:id/view`). */
function ViewTenant(props) {
  return <ViewLead {...props} type="client" />;
}

export default ViewTenant;
